import React from 'react';
import '../Component/cards.css'

const CardsTimeLine = () => {
    return (
        <div className="main" id='experience'>
            <h3 className="head" data-aos="fade-down">Experience</h3>
            <div className="container">
                <ul>
                    <li>
                    <div data-aos="fade-left">
                        <h3 className="heading">Front-End Developer</h3>
                        <p>
                            
                        Experienced Front-End Developer proficient in HTML, CSS, and JavaScript. Skilled in creating responsive layouts, interactive features, and optimizing website performance. Familiar with React and NEXT.JS frameworks, dedicated to staying updated with the latest web technologies.
                        </p>
                        <span className="date">January 2023</span>
                        <span className="circle"></span>
                    </div>
                    </li>
                    <li>
                    <div data-aos="fade-right">
                        <h3 className="heading">Back-End Developer</h3>
                        <p>
                        Experienced Back-End Developer proficient in Node.js, building robust and scalable applications. Expertise in designing and implementing RESTful APIs, database management, and server-side logic.
                        </p>
                        <span className="date">July 2023</span>
                        <span className="circle"></span>
                    </div>
                    </li>
                    <li >
                    <div data-aos="fade-left">
                        <h3 className="heading">Full Stack Developer</h3>
                        <p>
                        As a proficient Full Stack Developer specialized in MERN (MongoDB, Express, React, Node.js) stack, I excel in crafting dynamic web applications with seamless functionality. With expertise in front-end and back-end technologies.
                        </p>
                        <span className="date">September 2023</span>
                        <span className="circle"></span>
                    </div>

                    </li>
                    <li>
                        <div  data-aos="fade-right">
                        <h3 className="heading">App Developer</h3>
                        <p>
                        Experienced React Native developer proficient in building cross-platform Mobile Applications. Skilled in using Redux for state management, integrating APIs, and optimizing app performance. Familiar with UI frameworks like React Navigation and capable of delivering high-quality, user-friendly mobile experiences.
                        </p>
                        <span className="date">November 2023</span>
                        <span className="circle"></span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default CardsTimeLine;
